import { CityLandingPage } from "../components/CityLandingPage";

export function WebdesignerDresden() {
  return <CityLandingPage city="Dresden" citySlug="dresden" variant="webdesigner" />;
}
